var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
  'outcomes-header-bet-outcomes',
  `outcomes-length-${_vm.outcomesLength}`,
  { 'most-balanced': _vm.mostBalanced }
  ]},_vm._l((_vm.sportBet.outcomes),function(outcome){return _c('BetOutcome',{key:outcome.id,attrs:{"outcome":outcome}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }